<template>
  <transactions-table
    :is-billsRegistryItems-loading="isBillsRegistryItemsLoading"
    class="payouts-registries-table"
    grid-template-columns="82px 1.2fr 1fr 1.1fr 1.2fr 1fr 140px 60px"
  >
    <template #tableHeader>
      <transactions-table-header
        class="transactions-table__header"
        :header-cols="$options.BILLS_HEADER_COLS"
        @sortChanged="handleSortChanged"
      ></transactions-table-header>
    </template>
    <template #transactionItems>
      <bills-registry-main-table-item
        v-for="registryItem in billsRegistryItemsPaged"
        :bills-registry-item="registryItem"
        :key="registryItem.id"
        @repeatPayout="handleRepeatPayout"
      ></bills-registry-main-table-item>
    </template>
    <template #tablePagination>
      <transactions-table-pagination
        @changePage="handlePageChanged"
        :current-page="currentPage"
        :items-count="billsRegistryItemsFiltered.length"
        :per-page="perPage"
      ></transactions-table-pagination>
    </template>
  </transactions-table>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import TransactionsTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import TransactionsTablePagination from '@vue-app/components/company/transactions/table/TransactionsTablePagination.vue'
import PayoutsToCardTableItem from '@vue-app/components/company/payouts/to-card/table/item/PayoutsToCardTableItem.vue'
import PayoutsRegistryTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryTableItem.vue'
import { mapState } from 'vuex'
import PayoutsRegistryCreatedTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryCreatedTableItem.vue'
import PayoutsRegistryMainTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryMainTableItem.vue'
import BillsRegistryMainTableItem from '@vue-app/components/company/bills/by-registry/main/table/item/BillsRegistryMainTableItem.vue'

export default {
  name: 'BillsRegistryMainTable',
  components: {
    PayoutsRegistryMainTableItem,
    PayoutsRegistryCreatedTableItem,
    PayoutsRegistryTableItem,
    PayoutsToCardTableItem,
    TransactionsTablePagination,
    TransactionsTableItem,
    TransactionsTableHeader,
    TransactionsTable,
    BillsRegistryMainTableItem,
  },
  props: {
    billsRegistryItems: {
      type: [Array, Object],
      default() {
        return []
      },
    },
    isBillsRegistryItemsLoading: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    sort: {
      col: null,
      dir: null,
    },
  }),
  BILLS_HEADER_COLS: [
    {
      id: 'date',
      title: 'bills.by-registry.created.table.column.date',
      additionalClasses: ['transactions-table-header__col--date'],
    },
    {
      id: 'recipient',
      title: 'bills.by-registry.created.table.column.recipient',
      additionalClasses: ['transactions-table-header__col--recipient'],
    },
    {
      id: 'phone',
      title: 'bills.by-registry.created.table.column.phone',
      additionalClasses: ['transactions-table-header__col--phone'],
    },
    {
      id: 'email',
      title: 'bills.by-registry.created.table.column.email',
      additionalClasses: ['transactions-table-header__col--email'],
    },
    {
      id: 'account-number',
      title: 'bills.by-registry.created.table.column.account-number',
      additionalClasses: ['transactions-table-header__col--account-number'],
    },
    {
      id: 'appointment',
      title: 'bills.by-registry.created.table.column.appointment',
      additionalClasses: ['transactions-table-header__col--appointment'],
    },
    {
      id: 'sum',
      title: 'bills.by-registry.created.table.column.sum',
      additionalClasses: ['transactions-table-header__col--sum'],
    },
    {
      id: 'status',
      title: 'bills.by-registry.created.table.column.status',
      additionalClasses: ['transactions-table-header__col--status'],
    },
    {
      id: 'action',
      title: 'bills.by-registry.created.table.column.action',
      additionalClasses: ['transactions-table-header__col--action'],
    },
  ],
  computed: {
    ...mapState(['selectedCompany']),
    billsRegistryItemsPaged() {
      let _startFrom = (this.currentPage - 1) * this.perPage
      return this.billsRegistryItemsFiltered.slice(
        _startFrom,
        _startFrom + this.perPage
      )
    },
    billsRegistryItemsFiltered() {
      let _transactionToProcess = [...this.billsRegistryItems.bills]

      this.currentPage = 1

      return _transactionToProcess
    },
  },
  methods: {
    handlePayoutsRegistryItemDeleted(billsRegistryItem) {
      $emit(this, 'registryPositionDeleted', billsRegistryItem)
    },
    handlePayoutsRegistryItemUpdated(billsRegistryItem) {
      $emit(this, 'registryPositionUpdated', billsRegistryItem)
    },
    handlePageChanged(page) {
      this.currentPage = page
    },
    handleSortChanged(newSort) {
      this.sort = { ...newSort }
    },
    handleRepeatPayout(registryItem) {
      $emit(this, 'repeatPayoutsRegistryItem', registryItem)
    },
  },
  emits: [
    'registryPositionDeleted',
    'registryPositionUpdated',
    'repeatPayoutsRegistryItem',
    ,
  ],
}
</script>

<style lang="scss" scoped>
.payouts-registries-table {
  :deep(.transactions-table) {
    .transactions-table__header {
      display: flex;
      align-items: center;
      padding: 30px 10px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      border-bottom: 1px solid #eff2f8;
    }

    .transactions-table__body {
      background: #ffffff;
      border-radius: 0 0 20px 20px;
      padding-bottom: 30px;
    }
  }

  :deep(.transactions-table-header) {
    .transactions-table-header__col {
      flex: 1;
      .transactions-table-header__col--date {
        justify-content: flex-start;
      }
      .transactions-table-header__col--account-number {
        justify-content: center;
      }

      .transactions-table-header__col--phone,
      .transactions-table-header__col--recipient,
      .transactions-table-header__col--email,
      .transactions-table-header__col--account-number {
        .transactions-table-header__col-text {
          width: 110px;
        }
      }
      .transactions-table-header__col--sum,
      .transactions-table-header__col-commission {
        justify-content: center;
      }

      .transactions-table-header__col--p-sum,
      .transactions-table-header__col--p-count {
        justify-content: flex-end;
      }

      .transactions-table-header__col--status {
        justify-content: center;
      }

      .transactions-table-header__col--action {
        margin-right: 35px;
        justify-content: flex-end;
      }
    }
  }
}
</style>
